import { render, staticRenderFns } from "./RemoveSensor.vue?vue&type=template&id=f04723dc&scoped=true&"
import script from "./RemoveSensor.vue?vue&type=script&lang=js&"
export * from "./RemoveSensor.vue?vue&type=script&lang=js&"
import style0 from "./RemoveSensor.vue?vue&type=style&index=0&id=f04723dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04723dc",
  null
  
)

export default component.exports